export default "__VITE_ASSET__XwQF1dVJ__"